export const USER_ID_IDENTIFIER = '@loophealth';

export enum PATIENT_TYPE {
    MEMBERSHIP = 'memebership'
}
